import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Category = lazy(() => import('./Category'))
const Topics = lazy(() => import('./Topics'))

const DataSetupsRoutes = [
    {
        path: '/category',
        component: Category,
        auth: authRoleAccess.adminOnly,
    },
    {
        path: '/topics',
        component: Topics,
        auth: authRoleAccess.adminOnly,
    },
]

export default DataSetupsRoutes 